export const LANG_SE_SV = 'se_sv';
export const LANG_US_EN = 'us_en';
